module.exports = __webpack_public_path__ + "static/monei_pay_group_en_1-be3d5a9a50c7dbad10c312e3f96c28b7.png";